import React from "react";
import { Button, ButtonProps, Heading, Modal, ModalProps, RequiredKeys } from "@hex-insights/core";
import { ContractLineItemForm } from "../../../Forms";

export type ContractLineItemCreateModalControllerProps = Omit<ButtonProps, "onClick"> &
	Pick<ContractLineItemCreateModalProps, "formStateArgs" | "formNameSuffix">;

export function ContractLineItemCreateModalController({
	formStateArgs,
	formNameSuffix,
	...props
}: ContractLineItemCreateModalControllerProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	return (
		<React.Fragment>
			<Button onClick={openModal} {...props} />

			<Modal.If condition={isModalOpen}>
				<ContractLineItemCreateModal
					formStateArgs={formStateArgs}
					formNameSuffix={formNameSuffix}
					onClose={closeModal}
				/>
			</Modal.If>
		</React.Fragment>
	);
}

export type ContractLineItemCreateModalProps = Pick<
	ContractLineItemForm.ControlledCreateProps,
	"formStateArgs" | "formNameSuffix"
> &
	RequiredKeys<Pick<ModalProps, "ifRef" | "onClose" | "className" | "style">, "onClose">;

export function ContractLineItemCreateModal({
	formStateArgs,
	formNameSuffix,
	ifRef,
	onClose,
	className,
	style,
}: ContractLineItemCreateModalProps) {
	return (
		<Modal ifRef={ifRef} onClose={onClose} className={className} style={style}>
			<Modal.Header>
				<Heading.H2 noMargin>New Service</Heading.H2>
			</Modal.Header>
			<Modal.Body>
				<ContractLineItemForm.ControlledCreate
					formStateArgs={formStateArgs}
					formNameSuffix={formNameSuffix}
					onSuccess={onClose}
				/>
			</Modal.Body>
		</Modal>
	);
}
